/*
 * Voyado PLP URL-state helpers — extracted from voyado-plp-controller.js
 * (TECH-DEBT #93: keep the controller under the 500-LOC hard ceiling, D29).
 * Pure, DOM-free functions: they read location / sessionStorage / performance /
 * URLSearchParams only — never the document tree. Exposed on window so the
 * non-bundled controller can consume them (same pattern as window.VoyadoPlp).
 *
 * Behaviour is byte-identical to the original controller bodies — do NOT edit
 * the logic here; this file is a pure relocation.
 */
;(function () {
  'use strict';

  const PAGE_SIZE = 24;

  // Facet selections are sent as f.<id> query params (Voyado Query Parameters
  // format) — value facets join with `|`, range facets split into
  // f.<id>.min / f.<id>.max.
  function facetParams(facets) {
    const out = {};
    Object.keys(facets || {}).forEach(function (id) {
      const v = facets[id];
      if (Array.isArray(v)) { if (v.length) out['f.' + id] = v.join('|'); }
      else if (v && typeof v === 'object') {
        if (v.min != null) out['f.' + id + '.min'] = v.min;
        if (v.max != null) out['f.' + id + '.max'] = v.max;
      }
    });
    return out;
  }

  // Keyed by path + query so a filtered/sorted state restores its own count.
  function plpRestoreKey() { return 'voyado-plp:' + location.pathname + location.search; }

  function readRestore(key) {
    const nav = (window.performance.getEntriesByType('navigation') || [])[0];
    if (!nav || nav.type !== 'back_forward') return null;
    try {
      const s = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!s || !(s.count > PAGE_SIZE)) return null;
      return { count: Math.min(s.count, 240), scroll: s.scroll || 0 };
    } catch (e) { return null; }
  }

  function saveRestore(key, data) {
    try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) { /* quota / private mode */ }
  }

  function readFacetsFromUrl() {
    const out = {};
    new URLSearchParams(location.search).forEach(function (val, key) {
      if (key.indexOf('f.') !== 0) return;
      const body = key.slice(2);
      if (body.endsWith('.min') || body.endsWith('.max')) {
        const id = body.slice(0, body.lastIndexOf('.'));
        const bound = body.slice(body.lastIndexOf('.') + 1);
        out[id] = out[id] && typeof out[id] === 'object' && !Array.isArray(out[id]) ? out[id] : {};
        out[id][bound] = Number(val);
      } else {
        out[body] = val.split('|');
      }
    });
    return out;
  }

  window.VoyadoPlpUrl = {
    facetParams: facetParams,
    plpRestoreKey: plpRestoreKey,
    readRestore: readRestore,
    saveRestore: saveRestore,
    readFacetsFromUrl: readFacetsFromUrl
  };
})();
